import integrationService from '@/services/integration';

export default {
  updateGoogleShoppingCardSearchProduct({ commit }, payload) {
    integrationService.googleSearchProduct(payload).then(res => {
      commit('updateGoogleShoppingIntegrationSearchProduct', res.data.data);
    });
  },
  updateGoogleShoppingCardSearchIncludedProducts({ commit }) {
    integrationService.googleIncludedProducts().then(res => {
      commit('updateGoogleShoppingIntegrationSearchIncludedProducts', res.data.data);
    });
  },
  updateGoogleShoppingCardIncludeProduct({ commit }, payload) {
    integrationService.googleIncludeProduct(payload).then(res => {
      commit('updateGoogleShoppingIntegrationIncludeProduct', res.data.data);
    });
  },
  updateGoogleShoppingCardExcludeProduct({ commit }, payload) {
    integrationService.googleExcludeProduct(payload).then(res => {
      commit('updateGoogleShoppingIntegrationExcludeProduct', res.data.data);
    });
  },
  getGoogleShoppingAuthLink({ _ }) {
    return integrationService.getGoogleShoppingAuthLink();
  },
  revokeGoogleLogin({ dispatch, commit }) {
    return integrationService
      .revokeGoogleLogin()
      .then(() => {
        dispatch('getGoogleShoppingIntegrationStatus');
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.googleFeed.message.accessRevoked',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Account.snackbarErrorText',
          },
          {
            root: true,
          }
        );
      });
  },
  syncGoogleMerchants({ dispatch, commit }) {
    return integrationService
      .syncGoogleMerchants()
      .then(() => {
        dispatch('getGoogleShoppingIntegrationStatus');
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.googleFeed.message.syncStarted',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Account.snackbarErrorText',
          },
          {
            root: true,
          }
        );
      });
  },
  getGoogleShoppingIntegrationStatus({ commit, dispatch }) {
    return integrationService.getGoogleShoppingIntegrationStatus().then(res => {
      commit('updateGoogleShoppingIntegrationStatus', res.data);

      if (res.data.syncRunning) {
        setTimeout(() => dispatch('getGoogleShoppingIntegrationStatus'), 2000);
      } else {
        dispatch('loadIntegrationProducts', {
          integrationName: 'google-merchant',
        });
      }
    });
  },
  getBazaarvoiceIntegrationStatus({ commit, dispatch }) {
    return integrationService.getBazaarvoiceIntegrationStatus().then(res => {
      commit('updateBazaarvoiceIntegrationStatus', res.data);

      if (res.data.syncRunning) {
        setTimeout(() => dispatch('getBazaarvoiceIntegrationStatus'), 2000);
      } else {
        dispatch('loadIntegrationProducts', { integrationName: 'bazaarvoice' });
      }
    });
  },
  setIntegrationProductsPagination({ commit }, payload) {
    commit('setIntegrationProductsPagination', payload);
  },
  loadIntegrationProducts({ commit, state }, { integrationName, product }) {
    commit('setIntegrationProductsLoading', true);
    return integrationService
      .loadIntegrationProducts(integrationName, product?.id, state.integrationProducts.pagination)
      .then(res => {
        commit('loadIntegrationProductsSuccess', res);
      });
  },
  linkIntegrationProduct(
    { commit, dispatch },
    { integrationName, selectedProduct, integrationProductId }
  ) {
    commit('setIntegrationProductsLoading', true);
    return integrationService
      .linkIntegrationProduct(integrationName, selectedProduct.id, integrationProductId)
      .then(() => {
        dispatch('loadIntegrationProducts', integrationName, selectedProduct);
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.googleFeed.message.linkSuccess',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Account.snackbarErrorText',
          },
          {
            root: true,
          }
        );
      });
  },
  unlinkIntegrationProduct(
    { commit, dispatch },
    { integrationName, selectedProduct, integrationProductId }
  ) {
    commit('setIntegrationProductsLoading', true);
    return integrationService
      .unlinkIntegrationProduct(integrationName, integrationProductId)
      .then(() => {
        dispatch('loadIntegrationProducts', integrationName, selectedProduct);
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.googleFeed.message.unlinkSuccess',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Account.snackbarErrorText',
          },
          {
            root: true,
          }
        );
      });
  },
  runGoogleProductsSync({ dispatch, commit }) {
    return integrationService
      .runGoogleProductsSync()
      .then(() => {
        dispatch('getGoogleShoppingIntegrationStatus');
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.googleFeed.message.syncStarted',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Account.snackbarErrorText',
          },
          {
            root: true,
          }
        );
      });
  },
  runGoogleMerchantProductsSync({ dispatch, commit, state }) {
    return integrationService
      .runGoogleMerchantProductsSync(state.googleShoppingInfo.selectedMerchantId)
      .then(() => {
        dispatch('getGoogleShoppingIntegrationStatus');
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.googleFeed.message.syncStarted',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Account.snackbarErrorText',
          },
          {
            root: true,
          }
        );
      });
  },
  runBazaarvoiceProductsSync({ dispatch, commit }) {
    return integrationService
      .runBazaarvoiceProductsSync()
      .then(() => {
        dispatch('getBazaarvoiceIntegrationStatus');
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.bazaarvoice.syncStarted',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Account.snackbarErrorText',
          },
          {
            root: true,
          }
        );
      });
  },
  runBazaarvoiceReviewsSync({ dispatch, commit }) {
    return integrationService
      .runBazaarvoiceReviewsSync()
      .then(() => {
        dispatch('getBazaarvoiceIntegrationStatus');
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.bazaarvoice.syncStarted',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Account.snackbarErrorText',
          },
          {
            root: true,
          }
        );
      });
  },
  deleteIntegrationProduct(
    { commit, dispatch },
    { integrationName, selectedProduct, integrationProductId }
  ) {
    commit('setIntegrationProductsLoading', true);
    return integrationService
      .deleteIntegrationProduct(integrationName, integrationProductId)
      .then(() => {
        dispatch('loadIntegrationProducts', integrationName, selectedProduct);
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.googleFeed.message.deleteSuccess',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Account.snackbarErrorText',
          },
          {
            root: true,
          }
        );
      });
  },
  updateBazaarvoiceSettings({ commit, dispatch }, payload) {
    return integrationService
      .updateBazaarvoiceSettings(payload)
      .then(res => {
        dispatch('getBazaarvoiceIntegrationStatus');
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Integration.bazaarvoice.updated',
          },
          {
            root: true,
          }
        );
        commit('updateAccountInfoBazaarvoicePreferences', res.data.data, {
          root: true,
        });
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'Integration.bazaarvoice.failedToUpdate',
          },
          {
            root: true,
          }
        );
      });
  },
};
